import { structureWithSchemaBasePrompt } from './structureBasePrompt';
export const generateStructureViewsPrompt = structureWithSchemaBasePrompt
    .temp(0.5)
    .human("It is important to keep application structure simple and user friendly. User should be able to do all tasks in application without any problems. Let's start with views.");
//# sourceMappingURL=generateStructureViewsPrompt.js.map